import { render, staticRenderFns } from "./VerifyEmailOTP.vue?vue&type=template&id=9afcb356&scoped=true&"
import script from "./VerifyEmailOTP.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailOTP.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailOTP.vue?vue&type=style&index=0&id=9afcb356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afcb356",
  null
  
)

component.options.__file = "VerifyEmailOTP.vue"
export default component.exports